import { PDFDict, PDFDocument, PDFName } from 'pdf-lib'

export function combinePdf() {
    /*
        fetchPromisesWithTypes: {
            fetchPromise: Promise,
            type: 'pdf' | 'png' | 'jpg' | 'jpeg'
        }[],
        {"byteArray" | "base64"} returnType;
    */
    return async (fetchPromisesWithTypes, returnType = "byteArray") => {
        try {
            const appendPdf = async (buffer) => {
                const sourcePdf = await PDFDocument.load(buffer);
                // Embedding only draws page content and drops annotations such as
                // handwritten signatures. Copy whole pages to preserve their layout and annotations.
                const pages = await pdfDoc.copyPages(sourcePdf, sourcePdf.getPageIndices());
                for (const page of pages) {
                    // pdf-lib can copy an annotation's page reference to a separate
                    // page object. Point it at the page actually added to the document.
                    const annotations = page.node.Annots();
                    for (let i = 0; i < (annotations?.size() ?? 0); i++) {
                        annotations.lookup(i, PDFDict).set(PDFName.of('P'), page.ref);
                    }
                    pdfDoc.addPage(page);
                }
            }
            
            const embedImage = async (buffer, embedder) => {
                const page = pdfDoc.addPage();
                const embed = await embedder(buffer);
                const dims = embed.scale(1);
                const maxWidth = page.getWidth() * 0.9;
                const maxHeight = page.getHeight() * 0.9;
                let width = dims.width;
                let height = dims.height;
                if (width > maxWidth) {
                    height = height / width * maxWidth;
                    width = width / width * maxWidth;
                } else if (height > maxHeight) {
                    width = width / height * maxHeight;
                    height = height / height * maxHeight;
                }

                const x = (page.getWidth() / 2) - (width / 2);
                const y = (page.getHeight() / 2) - (height / 2);
                return page.drawImage(embed, {
                    x: x >= 0 ? x : 0,
                    y: y >= 0 ? y : 0,
                    width: width,
                    height: height,
                });
            }

            const fetchPromises = fetchPromisesWithTypes.map(fetchPromiseWithType => fetchPromiseWithType.fetchPromise);
            const buffers = await Promise.all(fetchPromises);
            const pdfDoc = await PDFDocument.create();

            for (let i = 0; i < buffers.length; i++) {
                const buffer = buffers[i];
                const type = fetchPromisesWithTypes[i].type.toLowerCase();
                if (type === 'pdf') {
                    await appendPdf(buffer);
                } else if (type === 'png') {
                    await embedImage(buffer, pdfDoc.embedPng.bind(pdfDoc));
                } else if (type === 'jpg' || type === 'jpeg') {
                    await embedImage(buffer, pdfDoc.embedJpg.bind(pdfDoc));
                }
            }

            switch (returnType) {
                case "byteArray":
                    return pdfDoc.save();
                case "base64":
                    return pdfDoc.saveAsBase64();
                default:
                    return null;
            }
        } catch (e) {
            throw e;
        }
    };
};
